<template>
  <basic-portlet title="Timbre Releases" icon="">
    <collapse-portlet v-for="release in releases" :key="release.id"
                      :title="getReleaseTitle(release)"
                      :expanded="false" icon="flaticon2-rocket">
      <release-content :release="release" />
    </collapse-portlet>
  </basic-portlet>
</template>
<script>
import CollapsePortlet from "VueComponents/CollapsePortlet";
import BasicPortlet from "VueComponents/BasicPortlet";
import ReleaseContent from "VuePartials/Releases/ReleaseContent";

export default {
  components: { ReleaseContent, BasicPortlet, CollapsePortlet },
  data() {
    return {
      releases: window.releases,
    };
  },
  methods: {
    getReleaseTitle(release) {
      return `${release.name} - ${release.release_date}`;
    },
  },
};
</script>
